import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-20 d-sm-flex align-items-center justify-content-between letter-spacing" }
const _hoisted_2 = { class: "mb-5 mb-sm-0 fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "row loading"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"150px","margin-bottom":"400px"},
  src: "/images/loading.gif",
  alt: "Carregando..."
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_9 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0 text-center"
    }, " Atleta"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Quantidade "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Última Avaliação"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Altura Máxima (cm)"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Potência (W/kg)"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " RSI"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Deslocamento Horizontal (cm)"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Valgo Direita"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
    }, " Valgo Esquerda")
  ])
], -1)
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis text-center" }
const _hoisted_29 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.Lang("CountermovementJump")), 1)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientsData, (patient) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: patient.fileName
                        }, [
                          _createElementVNode("th", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(patient.content.demographic.name), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.countDateRepetitions(patient.content.performance.dates)), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.getLatestDate(patient.content.performance.dates)), 1),
                          _createElementVNode("td", _hoisted_18, [
                            _createTextVNode(_toDisplayString(JSON.stringify(patient.content.performance.jump_heights_max.current)) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDown(patient.content.performance.jump_heights_max.perc_variation)),
                              innerHTML: _ctx.loadingPercentage(patient.content.performance.jump_heights_max.perc_variation )
                            }, null, 10, _hoisted_19)
                          ]),
                          _createElementVNode("td", _hoisted_20, [
                            _createTextVNode(_toDisplayString(JSON.stringify(patient.content.performance.peak_powers_max.current)) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDown(patient.content.performance.peak_powers_max.perc_variation)),
                              innerHTML: _ctx.loadingPercentage(patient.content.performance.peak_powers_max.perc_variation )
                            }, null, 10, _hoisted_21)
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createTextVNode(_toDisplayString(JSON.stringify(patient.content.performance.adjusted_RSIs_mean.current)) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDown(patient.content.performance.adjusted_RSIs_mean.perc_variation)),
                              innerHTML: _ctx.loadingPercentage(patient.content.performance.adjusted_RSIs_mean.perc_variation )
                            }, null, 10, _hoisted_23)
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            _createTextVNode(_toDisplayString(patient.content.performance.body_displacemente.current) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDownInvert(patient.content.performance.body_displacemente.perc_variation)),
                              innerHTML: _ctx.loadingPercentageInvert(patient.content.performance.body_displacemente.perc_variation)
                            }, null, 10, _hoisted_25)
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createTextVNode(_toDisplayString((patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.values.at(-1) === null)? 0 : JSON.stringify(patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.values.at(-1))) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDown(JSON.stringify(patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.values.at(-1)))),
                              innerHTML: _ctx.loadingPercentage(patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.perc_variation)
                            }, null, 10, _hoisted_27)
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            _createTextVNode(_toDisplayString((patient.content.kinematic.Knee.Valgus_count.left.phases.propulsive.values.at(-1) === null)? 0 : JSON.stringify(patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.values.at(-1))) + " ", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.showClassUpOrDown(JSON.stringify(patient.content.kinematic.Knee.Valgus_count.right.phases.propulsive.values.at(-1)))),
                              innerHTML: _ctx.loadingPercentage(patient.content.kinematic.Knee.Valgus_count.left.phases.propulsive.perc_variation)
                            }, null, 10, _hoisted_29)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
  ], 64))
}